(($) => {
  $(() => {
    const $localizationForm = $('#localization_form');

    if ($localizationForm.length) {
      const $languageCodeInput = $localizationForm.find('input[name="language_code"]');

      $('#utility-menu, #mobile-menu').on('click', 'a[lang]', (e) => {
        const $a = $(e.currentTarget);
        const languageCode = $a.data('value');

        $languageCodeInput.val(languageCode);

        $localizationForm.trigger('submit');
      });
    }
  });
})(jQuery);
